<div class="d-flex align-items-center profile">
  <button #button class="p-0 btn" (click)="open(content)">
    <img src="assets/image/profile.svg" />
  </button>
</div>

<ng-template #content let-offcanvas>
  <div class="profile-menu-wrapper">
    <div class="offcanvas-header">
      <div class="d-flex flex-column">
        <div class="profile-label">{{ 'NAME' | translate }}</div>
        <div>{{ (user$ | async)?.firstName }} {{ (user$ | async)?.lastName }}</div>
      </div>

      <div class="d-flex flex-column">
        <div class="profile-label">{{ 'EMAIL' | translate }}</div>
        <div>{{ (user$ | async)?.email }}</div>
      </div>
    </div>
    <div class="offcanvas-body main">
      <div class="d-flex flex-column">
        <div class="h-100 d-flex align-items-center">
          <a class="logout" (click)="logOut()">
            <fa-icon [icon]="['fas', 'arrow-right-from-bracket']"></fa-icon>
            <span>{{ 'Log out' | translate }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>
